function ResolveUrl(url) {
    var baseUrl = "/";
    var rc;
    if (url != null && url.indexOf("~/") === 0) {
        rc = baseUrl + url.substring(2);
    }
    else {
        rc = baseUrl + url;
    }
    return rc;
}
function ResolveUrlWithBase(url) {
    var rc;
    if (url != null && url.indexOf("~/") === 0) {
        rc = "/" + url.substring(2);
    }
    else {
        rc = url;
    }
    return rc;
}
function SetHelpDocuments(HelpDocs) {
    $("#helpdoc").empty();
    if (HelpDocs !== null && typeof HelpDocs !== "undefined") {
        if (Array.isArray(HelpDocs) === true) {
            $.each(HelpDocs, function (i, v) {
                $("<a></a>").attr("href", v)
                    .addClass("helpdoc-doc")
                    .prependTo("#helpdoc");
            });
        }
        else {
            $("<a></a>").attr("href", HelpDocs)
                .addClass("helpdoc-doc")
                .appendTo("#helpdoc");
        }
        $("#topmenu-help-menuitem").show();
    }
    else {
        $("#topmenu-help-menuitem").hide();
    }
}
function linkToKnowledgeBase(e) {
    e.preventDefault();
    window.open("/help/KB.aspx");
}
$(function () {
    ShowHideExportCsv();
});
function ShowHideExportCsv() {
    if (window.ExportCsv) {
        $("#topmenu-exportcsv").on('click', function (e) {
            window.ExportCsv();
        });
        $("#topmenu-exportcsv").css("color", "");
    }
    else {
        $("#topmenu-exportcsv").css("color", "transparent");
    }
}
function GetQueryStringValue(key) {
    key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&");
    var match = location.search.match(new RegExp("[?&]" + key + "=([^&]+)(&|$)", "i"));
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}
function SetQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        return uri + separator + key + "=" + value;
    }
}
(function ($) {
    $.extend({
        postJson: function (url, data, successCallback) {
            url = ResolveUrl(url);
            return $.ajax({
                type: "POST",
                url: url,
                data: JSON.stringify(data),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: successCallback
            });
        }
    });
})(jQuery);
function isValidDate(dateStr) {
    var dt = new Date(dateStr);
    if (Object.prototype.toString.call(dateStr) === "[object Date]" || !isNaN(dt.getTime())) {
        return true;
    }
    else {
        return false;
    }
}
function isValidDateRange(start, stop) {
    if (start == null || stop == null || !isValidDate(start) || !isValidDate(stop)) {
        return true;
    }
    var startdt = new Date(start);
    var stopdt = new Date(stop);
    startdt.setHours(0, 0, 0, 0);
    stopdt.setHours(0, 0, 0, 0);
    if (stopdt.getTime() >= startdt.getTime()) {
        return true;
    }
    return false;
}
function isValidGTDateRange(start, stop) {
    if (start == null || stop == null || !isValidDate(start) || !isValidDate(stop)) {
        return true;
    }
    var startdt = new Date(start);
    var stopdt = new Date(stop);
    startdt.setHours(0, 0, 0, 0);
    stopdt.setHours(0, 0, 0, 0);
    if (stopdt.getTime() > startdt.getTime()) {
        return true;
    }
    return false;
}
function isValidGTDateTimeRange(startDate, startHour, stopDate, stopHour) {
    if (startDate == null || stopDate == null || !isValidDate(startDate) || !isValidDate(stopDate)) {
        return true;
    }
    var startdt = new Date(startDate);
    var stopdt = new Date(stopDate);
    startdt.setHours(startHour, 0, 0, 0);
    stopdt.setHours(stopHour, 0, 0, 0);
    if (stopdt.getTime() > startdt.getTime()) {
        return true;
    }
    return false;
}
function isDateRecent(date) {
    var dt = new Date(date);
    if (dt > new Date("1/1/2000") && dt < new Date("1/1/2030")) {
        return true;
    }
    return false;
}
function dateEqual(firstDate, secondDate) {
    var date1 = new Date(firstDate);
    var date2 = new Date(secondDate);
    return (date1.getDate() === date2.getDate()
        && date1.getMonth() === date2.getMonth()
        && date1.getFullYear() === date2.getFullYear());
}
function isNumeric(num) {
    return !isNaN(num);
}
function putObject(path, object, value) {
    var modelPath = path.split(".");
    function fill(object, elements, depth, value) {
        var hasNext = ((depth + 1) < elements.length);
        if (depth < elements.length && hasNext) {
            if (!object.hasOwnProperty(modelPath[depth])) {
                object[modelPath[depth]] = {};
            }
            fill(object[modelPath[depth]], elements, ++depth, value);
        }
        else {
            object[modelPath[depth]] = value;
        }
    }
    fill(object, modelPath, 0, value);
}
(function ($) {
    $.fn.addCaption = function (captionStr) {
        return this.each(function () {
            var $caption = $(this).find("caption");
            if (!$caption.length) {
                $(this).prepend("<caption></caption>");
            }
        }).find("caption").html(captionStr);
    };
}(jQuery));
function isQuotaExceeded(e) {
    var quotaExceeded = false;
    if (e) {
        if (e.code) {
            switch (e.code) {
                case 22:
                    quotaExceeded = true;
                    break;
                case 1014:
                    if (e.name === "NS_ERROR_DOM_QUOTA_REACHED") {
                        quotaExceeded = true;
                    }
                    break;
            }
        }
        else if (e.number === -2147024882) {
            quotaExceeded = true;
        }
    }
    return quotaExceeded;
}
function isNullOrWhitespace(string) {
    var rc = false;
    if (!string || $.trim(string).length < 1) {
        rc = true;
    }
    return rc;
}
function IsNullOrUndefined(o) {
    var undefined = void (0);
    return !((undefined !== o) && (null !== o));
}
function IsValidInteger(value) {
    var isValid = false;
    if (null != value) {
        var valueInt = parseInt(value);
        if (!isNaN(valueInt)) {
            isValid = true;
        }
    }
    return isValid;
}
var ajaxCallGeneric = function (options) {
    var dfd = $.Deferred();
    var defaultOptions = {
        url: '',
        data: {},
        onErrorCallback: function () { dfd.reject(); }
    };
    var ajaxOptions = $.extend({}, defaultOptions, options || {});
    var query = $.ajax({
        type: 'POST',
        url: ajaxOptions.url,
        data: JSON.stringify(ajaxOptions.data),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: function (d) {
            dfd.resolve(d.d);
        },
        error: function (xhr, status, error) {
            ajaxOptions.onErrorCallback(dfd, xhr, status, error);
        }
    });
    return dfd.promise(query);
};
var formatDateMMddYYYY = function (dt) {
    if (true === IsNullOrUndefined(dt)) {
        return dt;
    }
    return dt.substring(5, 7) + '/' + dt.substring(8, 10) + '/' + dt.substring(0, 4);
};
